<script>

export default ({
  props: {
    filled: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    mostrarIcones: Boolean,
    obrigatorio: Boolean,
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    isConfigurarCelulaDialogOpen: Boolean,
    isDeletarComponenteDialogOpen: Boolean,
  },
})
</script>
